export default function NavigationItem({ page, pageNumber, goToPage }) {

  const handleClick = (e) => {
    e.preventDefault();
    goToPage(pageNumber);
  }
  
  return (
    <li key={pageNumber} className="on-nonmobile">
      <a
        className={pageNumber === page ? 'active' : ''}
        onClick={handleClick}
        href="#">{pageNumber}</a>
    </li>
  )
}